import { Button } from '@material-ui/core'
import { useState } from 'react'
import { useRedirect } from 'react-admin'

import { startFeasibilityCheck } from 'api/schedules'

interface FeasibilityStatButtonProps {
  kind: string
  id: string
  label: string
  disabled?: boolean
}

const FeasibilityStatButton = (props: FeasibilityStatButtonProps) => {
  const redirect = useRedirect()
  const [loading, setLoading] = useState(false)

  return (
    <Button
      disabled={loading}
      type="button"
      variant="contained"
      color="primary"
      onClick={async () => {
        setLoading(true)
        const feasibilityCheckResponse = await startFeasibilityCheck(props.kind, props.id)
        setTimeout(() => {
          setLoading(false)
          redirect(`/feasibility-stat?filter={"load":"${feasibilityCheckResponse.load_id}"}`)
        }, 3000)
      }}
    >
      {loading ? 'Redirecting...' : props.label}
    </Button>
  )
}

export default FeasibilityStatButton
